import styled, { css } from 'styled-components';
import { styleguide } from '../../../theme/styleguide';

type Breakpoint = keyof typeof styleguide.breakpoints;
type ResponsiveValue<T> = T | Partial<Record<Breakpoint, T>>;

export type BaseProps = {
  color?: string;
  size?: ResponsiveValue<string | number>;
  'aria-label'?: string;
  onClick?: () => void;
  alt?: string;
};

type IconProps = BaseProps & {
  children: React.ReactNode;
};

const Svg = styled.svg<{
  size: ResponsiveValue<string | number>;
  iconColor: string;
}>`
  display: inline-block;
  vertical-align: middle;
  color: ${({ iconColor }) => iconColor};

  ${({ size }) => {
    if (typeof size === 'string') {
      return `width: ${size}; height: ${size};`;
    }

    if (typeof size === 'number') {
      return `width: ${size}px; height: ${size}px;`;
    }

    return css`
      height: ${size.mobile}px;
      width: ${size.mobile}px;

      @media (min-width: ${styleguide.breakpoints.tablet}) {
        height: ${size.desktop}px;
        width: ${size.desktop}px;
      }
    `;
  }}
`;

function Icon({
  children,
  color = styleguide.colors.gray[100],
  size = '32px',
  'aria-label': ariaLabel,
}: IconProps) {
  return (
    <Svg
      size={size}
      iconColor={color}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      aria-label={ariaLabel}
    >
      {children}
    </Svg>
  );
}

export default Icon;
